/* Veiluxe plan finder (Cofounder, 2026-10-24).
   Logic is pure and exported on window.VLXQuiz so tests/quiz.test.mjs can run it in Node.
   Copy lives in vlx-quiz-copy.js. Config (variants, prices, codes, stock) comes from the
   section as JSON, so prices always match pricing.md and the landing page codes. */
(function () {
  'use strict';

  var FLOWS = {
    start: ['area'],
    hair: ['area', 'who', 'concern', 'since', 'scalp', 'tried'],
    skin: ['area', 'skin', 'steps'],
    both: ['area', 'who', 'concern', 'since', 'scalp', 'skin']
  };
  var SET_ITEMS = {
    set1: ['cleanser', 'toner', 'serum'],
    set2: ['cleanser', 'toner', 'serum', 'exf'],
    set3: ['cleanser', 'toner', 'serum', 'exf', 'oil']
  };
  var SAVE_KEY = 'vlxQuizPlan';
  var SAVE_DAYS = 14;

  /** @param {string|undefined} area @returns {string[]} */
  function flowFor(area) { return FLOWS[area] || FLOWS.start; }

  /** Bottles of hair oil to pre-select. Honest first: bald patches start at 1. */
  function hairQty(a) {
    if (a.concern === 'bald') return 1;
    if (a.concern === 'dry' && a.since !== 'years' && a.tried !== 'many') return 2;
    return 3;
  }

  /** Skincare pick: one product or a routine set. Sensitive skin never gets the acids set. */
  function skinPick(a) {
    var c = a.skin, s = a.steps;
    if (c === 'sensitive') return s === 'one' ? 'toner' : 'set1';
    if (c === 'dry') return s === 'one' ? 'serum' : (s === 'four' ? 'set2' : 'set1');
    return s === 'one' ? 'exf' : (s === 'four' ? 'set2' : 'set1');
  }

  function hairOffer(cfg, qty) {
    var t = cfg.hair.filter(function (x) { return x.qty === qty; })[0];
    return { id: 'hair' + qty, items: [{ key: 'oil', qty: qty }], price: t.price, was: t.was, code: t.code, qty: qty };
  }

  function skinOffer(cfg, key) {
    if (SET_ITEMS[key]) {
      var st = cfg.sets[key];
      return { id: key, items: SET_ITEMS[key].map(function (k) { return { key: k, qty: 1 }; }), price: st.price, was: st.was, code: st.code };
    }
    var p = cfg.products[key];
    return { id: key, items: [{ key: key, qty: 1 }], price: p.price, was: p.was, code: '' };
  }

  function isAvailable(offer, cfg) {
    return offer.items.every(function (it) { var p = cfg.products[it.key]; return p && p.ok && p.v; });
  }

  /** Delivery and total for one offer. */
  function totals(offer, cfg) {
    var delivery = offer.price >= cfg.freeShipAt ? 0 : cfg.shipping;
    return { delivery: delivery, total: offer.price + delivery };
  }

  /** Checkout link, same pattern as the landing page: /discount/CODE?redirect=/cart/V:Q,V:Q */
  function cartLink(offer, cfg) {
    var path = '/cart/' + offer.items.map(function (it) { return cfg.products[it.key].v + ':' + it.qty; }).join(',');
    return offer.code ? '/discount/' + encodeURIComponent(offer.code) + '?redirect=' + encodeURIComponent(path) : path;
  }

  /** The whole result: offers to show, which one is pre-selected, reasons and safety notes. */
  function recommend(a, cfg) {
    var offers, selected = 0, reasons = [], notes = [];
    if (a.area === 'skin') {
      var pick = skinPick(a);
      var alt = pick === 'set1' ? 'set2' : 'set1';
      if (a.skin === 'sensitive' && alt === 'set2') alt = 'toner';
      offers = [skinOffer(cfg, pick), skinOffer(cfg, alt)];
      reasons.push('skin_' + (a.skin || 'dry'));
      if (SET_ITEMS[pick]) reasons.push('skin_set');
    } else if (a.area === 'both') {
      offers = [skinOffer(cfg, 'set3'), hairOffer(cfg, hairQty(a))];
      reasons.push('both');
    } else {
      var q = hairQty(a);
      offers = [hairOffer(cfg, 1), hairOffer(cfg, 2), hairOffer(cfg, 3)];
      selected = q - 1;
      reasons.push(q === 3 ? 'slow' : (q === 2 ? 'dry' : 'bald'));
      if (q === 3) reasons.push('value', 'pack_guarantee');
    }
    if (a.tried === 'many') reasons.push('guarantee');
    if (a.who === 'other') reasons.push('phone');

    if (a.concern === 'bald') notes.push('derm');
    if (a.scalp === 'flakes') notes.push('dandruff');
    if (a.concern === 'postpartum') notes.push('breastfeed');
    if (a.tried === 'doctor') notes.push('doctor');
    if (a.scalp === 'sensitive' || a.skin === 'sensitive') notes.push('patch');
    if (a.skin === 'acne') notes.push('acne');

    var chosen = offers[selected];
    offers = offers.filter(function (o) { return isAvailable(o, cfg); });
    selected = Math.max(0, offers.indexOf(chosen));
    if (offers.some(function (o) { return o.items.some(function (it) { return it.key === 'exf'; }); })) notes.push('acids');
    return { offers: offers, selected: selected, reasons: reasons, notes: notes };
  }

  /** 4497 -> "Rs. 4,497" */
  function fmt(n) { return 'Rs. ' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function pct(price, was) { return was > price ? Math.floor((1 - price / was) * 100) : 0; }

  var api = { flowFor: flowFor, hairQty: hairQty, skinPick: skinPick, recommend: recommend, cartLink: cartLink, totals: totals, fmt: fmt, pct: pct };
  if (typeof window !== 'undefined') window.VLXQuiz = api;
  if (typeof document === 'undefined') return;

  /* ---------- UI ---------- */
  var root = document.getElementById('vq');
  var COPY = window.VLX_QUIZ_COPY;
  if (!root || !COPY) return;
  var cfg;
  try { cfg = JSON.parse(document.getElementById('vq-config').textContent); } catch (e) { return; }

  var state = { lang: cfg.lang === 'ur' ? 'ur' : 'en', i: -1, answers: {}, result: null };
  var view = root.querySelector('.vq-view');
  var live = root.querySelector('.vq-live');

  function t(x, vars) {
    var s = x ? (x[state.lang] !== undefined ? x[state.lang] : x.en) : '';
    if (vars && typeof s === 'string') Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('vlx_quiz_' + name, data || {}); } catch (e) {}
    try { if (window.gtag) window.gtag('event', 'quiz_' + name, data || {}); } catch (e) {}
    try { if (window.clarity) window.clarity('event', 'quiz_' + name); } catch (e) {}
  }
  function readSaved() {
    try {
      var raw = window.localStorage.getItem(SAVE_KEY);
      var p = raw && JSON.parse(raw);
      if (p && p.answers && Date.now() - p.at < SAVE_DAYS * 864e5) return p;
    } catch (e) {}
    return null;
  }
  function save(answers) { try { window.localStorage.setItem(SAVE_KEY, JSON.stringify({ answers: answers, at: Date.now() })); } catch (e) {} }

  function paint(html, focusSel) {
    view.classList.remove('in');
    view.innerHTML = html;
    void view.offsetWidth;
    view.classList.add('in');
    var f = view.querySelector(focusSel || 'h2');
    if (f) { f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); }
    root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    root.querySelector('.vq-lang').textContent = t(COPY.ui.lang_switch);
  }

  function renderIntro() {
    state.i = -1;
    setProgress(0);
    var saved = readSaved();
    paint(
      '<p class="vq-kick">' + esc(t(COPY.ui.kicker)) + '</p>' +
      '<h2>' + esc(t(COPY.ui.intro_title)) + '</h2>' +
      '<p class="vq-sub">' + esc(t(COPY.ui.intro_sub)) + '</p>' +
      '<ul class="vq-chips">' + t(COPY.ui.chips).map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul>' +
      '<button class="vq-btn" data-act="start">' + esc(t(COPY.ui.start)) + '</button>' +
      (saved ? '<button class="vq-link" data-act="resume">' + esc(t(COPY.ui.resume)) + '</button>' : '')
    );
  }

  function setProgress(frac) { root.style.setProperty('--vq-p', String(frac)); }

  function renderStep() {
    var flow = flowFor(state.answers.area);
    var id = flow[state.i];
    var step = COPY.steps[id];
    var total = state.answers.area ? flow.length : FLOWS.hair.length;
    setProgress(state.i / total);
    live.textContent = t(COPY.ui.count, { n: state.i + 1, t: total });
    var chosen = state.answers[id];
    paint(
      '<p class="vq-count">' + esc(t(COPY.ui.count, { n: state.i + 1, t: total })) + '</p>' +
      '<h2>' + esc(t(step.q)) + '</h2>' +
      '<div class="vq-opts" role="group">' + step.options.map(function (o, k) {
        return '<button class="vq-opt" style="--i:' + k + '" data-v="' + esc(o.v) + '" aria-pressed="' + (chosen === o.v) + '">' + esc(t(o.label)) + '</button>';
      }).join('') + '</div>' +
      '<div class="vq-note" hidden></div>' +
      (state.i > 0 ? '<button class="vq-link" data-act="back">' + esc(t(COPY.ui.back)) + '</button>' : '')
    );
  }

  function choose(v) {
    var flow = flowFor(state.answers.area);
    var id = flow[state.i];
    var opt = COPY.steps[id].options.filter(function (o) { return o.v === v; })[0];
    state.answers[id] = v;
    if (id === 'area') state.answers = { area: v };
    track('answer', { step: id, value: v });
    Array.prototype.forEach.call(view.querySelectorAll('.vq-opt'), function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === v)); });
    if (opt && opt.note) {
      var box = view.querySelector('.vq-note');
      box.innerHTML = '<p class="vq-note-h">' + esc(t(COPY.ui.good_to_know)) + '</p><p>' + esc(t(opt.note)) + '</p><button class="vq-btn" data-act="next">' + esc(t(COPY.ui.next)) + '</button>';
      box.hidden = false;
      box.querySelector('button').focus({ preventScroll: true });
      box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      return;
    }
    setTimeout(next, 220);
  }

  function next() {
    state.i += 1;
    if (state.i >= flowFor(state.answers.area).length) return renderResult();
    renderStep();
  }

  function offerTitle(o) { return t(COPY.offers[o.id]); }

  function renderResult() {
    var r = recommend(state.answers, cfg);
    state.result = r;
    setProgress(1);
    save(state.answers);
    track('complete', { area: state.answers.area, offer: r.offers[r.selected] && r.offers[r.selected].id });
    if (!r.offers.length) {
      paint('<h2>' + esc(t(COPY.ui.sold_out)) + '</h2>' + waLinks(null));
      return;
    }
    var hair = state.answers.area !== 'skin';
    paint(
      '<p class="vq-kick">' + esc(t(COPY.ui.result_kicker)) + '</p>' +
      '<h2>' + esc(offerTitle(r.offers[r.selected])) + '</h2>' +
      '<div class="vq-why"><p class="vq-note-h">' + esc(t(COPY.ui.why)) + '</p><ul>' +
        r.reasons.map(function (k) { return '<li>' + esc(t(COPY.reasons[k])) + '</li>'; }).join('') + '</ul></div>' +
      '<p class="vq-pick-h">' + esc(t(COPY.ui.choose)) + '</p>' +
      '<div class="vq-offers" role="radiogroup">' + r.offers.map(function (o, k) { return offerRow(o, k, k === r.selected); }).join('') + '</div>' +
      (hair && state.answers.area === 'hair' ? '<p class="vq-fine">' + esc(t(COPY.ui.pack_rule)) + '</p>' : '') +
      '<div class="vq-nudge" hidden></div>' +
      '<div class="vq-total"></div>' +
      '<a class="vq-btn vq-order" href="#" rel="nofollow">' + esc(t(COPY.ui.order)) + '</a>' +
      '<p class="vq-fine">' + esc(t(COPY.ui.ship_rule)) + '</p>' +
      '<div class="vq-card"><p class="vq-note-h">' + esc(t(COPY.ui.how_title)) + '</p><ol>' + t(COPY.ui.how_steps).map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ol></div>' +
      (r.notes.length ? '<div class="vq-card vq-warn"><p class="vq-note-h">' + esc(t(COPY.ui.notes_title)) + '</p><ul>' + r.notes.map(function (k) { return '<li>' + esc(t(COPY.notes[k])) + '</li>'; }).join('') + '</ul></div>' : '') +
      (hair ? '<div class="vq-card"><p class="vq-note-h">' + esc(t(COPY.ui.use_title)) + '</p><ul>' + t(COPY.ui.use_lines).map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('') + '</ul></div>' : '') +
      waLinks(r) +
      '<h3 class="vq-faq-h">' + esc(t(COPY.ui.faq_title)) + '</h3>' +
      COPY.faq.map(function (f) { return '<details class="vq-faq"><summary>' + esc(t(f.q)) + '</summary><p>' + esc(t(f.a)) + '</p></details>'; }).join('') +
      '<p class="vq-saved">' + esc(t(COPY.ui.saved)) + '</p>' +
      '<button class="vq-link" data-act="retake">' + esc(t(COPY.ui.retake)) + '</button>'
    );
    selectOffer(r.selected);
  }

  function offerRow(o, k, on) {
    var off = pct(o.price, o.was);
    var meta = [];
    if (o.qty > 1) meta.push(t(COPY.ui.per_bottle, { p: fmt(o.price / o.qty) }));
    if (o.was > o.price) meta.push(t(COPY.ui.save, { p: fmt(o.was - o.price) }));
    if (off) meta.push(t(COPY.ui.off, { n: off }));
    return '<button class="vq-offer" role="radio" style="--i:' + k + '" data-k="' + k + '" aria-checked="' + on + '">' +
      (k === state.result.selected ? '<span class="vq-tag">' + esc(t(COPY.ui.recommended)) + '</span>' : '') +
      '<span class="vq-dot" aria-hidden="true"></span><b>' + esc(offerTitle(o)) + '</b>' +
      '<span class="vq-price">' + esc(fmt(o.price)) + (o.was > o.price ? '<s>' + esc(fmt(o.was)) + '</s>' : '') + '</span>' +
      '<span class="vq-meta">' + esc(meta.join(' · ')) + '</span></button>';
  }

  function selectOffer(k) {
    var r = state.result;
    var o = r.offers[k];
    r.current = k;
    Array.prototype.forEach.call(view.querySelectorAll('.vq-offer'), function (b) { b.setAttribute('aria-checked', String(+b.getAttribute('data-k') === k)); });
    var tt = totals(o, cfg);
    view.querySelector('.vq-total').innerHTML =
      '<span>' + esc(t(COPY.ui.delivery)) + '</span><span>' + esc(tt.delivery ? fmt(tt.delivery) : t(COPY.ui.free)) + '</span>' +
      '<strong>' + esc(t(COPY.ui.total)) + '</strong><strong>' + esc(fmt(tt.total)) + '</strong>';
    var nudge = view.querySelector('.vq-nudge');
    var three = r.offers.map(function (x) { return x.id; }).indexOf('hair3');
    if (nudge) {
      var key = o.id === 'hair1' ? 'nudge_1' : (o.id === 'hair2' ? 'nudge_2' : '');
      nudge.hidden = !key || three < 0;
      nudge.innerHTML = key && three >= 0 ? '<p>' + esc(t(COPY.ui[key])) + '</p><button class="vq-link" data-act="pick3" data-k="' + three + '">' + esc(t(COPY.ui.nudge_cta)) + '</button>' : '';
    }
    var a = view.querySelector('.vq-order');
    a.setAttribute('href', cartLink(o, cfg));
    Array.prototype.forEach.call(view.querySelectorAll('[data-wa]'), function (w) { w.setAttribute('href', waHref(o)); });
  }

  function waHref(o) {
    var text = o ? t(COPY.ui.wa_text, { plan: offerTitle(o), total: fmt(totals(o, cfg).total) }) : t(COPY.ui.wa_text, { plan: '-', total: '-' });
    return 'https://wa.me/' + encodeURIComponent(cfg.wa) + '?text=' + encodeURIComponent(text);
  }
  function waLinks(r) {
    var o = r && r.offers[r.selected];
    return '<a class="vq-wa" data-wa="save" href="' + esc(waHref(o)) + '" target="_blank" rel="noopener">' + esc(t(COPY.ui.wa_save)) + '</a>' +
      '<a class="vq-wa vq-wa-q" data-wa="ask" href="' + esc(waHref(o)) + '" target="_blank" rel="noopener">' + esc(t(COPY.ui.wa_ask)) + '</a>';
  }

  root.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('button, a') : null;
    if (!el || !root.contains(el)) return;
    var act = el.getAttribute('data-act');
    if (el.classList.contains('vq-opt')) return choose(el.getAttribute('data-v'));
    if (el.classList.contains('vq-offer')) return selectOffer(+el.getAttribute('data-k'));
    if (el.classList.contains('vq-lang')) {
      state.lang = state.lang === 'ur' ? 'en' : 'ur';
      track('lang', { lang: state.lang });
      return state.result && state.i >= flowFor(state.answers.area).length ? renderResult() : (state.i < 0 ? renderIntro() : renderStep());
    }
    if (el.classList.contains('vq-order')) {
      var o = state.result.offers[state.result.current];
      track('order', { offer: o.id, value: totals(o, cfg).total });
      try { if (window.gtag) window.gtag('event', 'add_to_cart', { currency: 'PKR', value: totals(o, cfg).total }); } catch (err) {}
      el.textContent = t(COPY.ui.applying);
      return;
    }
    if (el.hasAttribute('data-wa')) return track('whatsapp', { kind: el.getAttribute('data-wa') });
    if (act === 'start') { state.answers = {}; state.result = null; track('start'); state.i = 0; return renderStep(); }
    if (act === 'resume') { var s = readSaved(); if (s) { state.answers = s.answers; state.i = flowFor(s.answers.area).length; track('resume'); return renderResult(); } }
    if (act === 'pick3') { track('nudge_3', {}); return selectOffer(+el.getAttribute('data-k')); }
    if (act === 'next') return next();
    if (act === 'back') { state.i = Math.max(0, state.i - 1); return renderStep(); }
    if (act === 'retake') { state.answers = {}; state.result = null; return renderIntro(); }
  });

  renderIntro();
})();
